"use client";

import React from "react";
import { motion } from "framer-motion";
const valuesData = [{
  id: "05",
  title: "Autenticità",
  desc: "Storie vere, persone vere. Niente filtri tra te e lei.",
  img: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1721445/img/lion_authentic.png",
  className: "md:col-start-1 md:row-start-1 md:row-span-2 lg:col-start-1 lg:row-start-1 lg:row-span-2"
}, {
  id: "01",
  title: "Condivisione",
  desc: "Niente ha senso da soli.",
  img: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1721445/img/lion_share.png",
  className: "md:col-start-2 md:row-start-1 lg:col-start-2 lg:row-start-1"
}, {
  id: "04",
  title: "Apertura",
  desc: "Non esiste una sola interpretazione.",
  img: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1721445/img/lion_open.png",
  className: "md:col-start-2 md:row-start-2 lg:col-start-2 lg:row-start-2"
}, {
  id: "03",
  title: "Ascolto",
  desc: "Prima di parlare, si ascolta.",
  img: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1721445/img/lion_listen.png",
  className: "md:col-start-1 md:row-start-3 md:row-span-2 lg:col-start-3 lg:row-start-1 lg:row-span-2"
}, {
  id: "02",
  title: "Coraggio",
  desc: "Dire le cose che nessuno dice.",
  img: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1721445/img/social_instagram_1.webp",
  className: "md:col-start-2 md:row-start-3 lg:col-start-4 lg:row-start-1"
}, {
  id: "06",
  title: "Curiosità",
  desc: "Fare domande vere.",
  img: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1721445/img/lion_curious.png",
  className: "md:col-start-2 md:row-start-4 lg:col-start-4 lg:row-start-2"
}];
const containerVariants = {
  hidden: {},
  show: {
    transition: {
      staggerChildren: 0.1
    }
  }
};
const itemVariants = {
  hidden: {
    opacity: 0,
    y: 30
  },
  show: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.6,
      ease: "easeOut"
    }
  }
};
export default function ValuesMasonryGrid() {
  return <section id="valuesmasonrygrid" className="w-full bg-background py-16 md:py-24 overflow-hidden">
      <div className="container mx-auto px-4 md:px-6 max-w-6xl">
        
        {}
        <motion.div initial={{
        opacity: 0,
        y: -20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        amount: 0.5
      }} transition={{
        duration: 0.5
      }} className="mb-12 md:mb-16">
          <span className="block text-sm font-bold tracking-widest text-primary uppercase mb-3 font-mono">
            Valori
          </span>
          <h2 className="text-4xl md:text-5xl lg:text-6xl font-bold text-foreground font-default tracking-tight">Come nasce l'idea e i valori</h2>
        </motion.div>

        {}
        <motion.div variants={containerVariants} initial="hidden" whileInView="show" viewport={{
        once: true,
        amount: 0.1
      }} className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4 auto-rows-[280px] md:auto-rows-[240px] lg:auto-rows-[260px]">
          {valuesData.map((item, i) => <motion.div key={item.id} data-index={i} variants={itemVariants} className={`relative overflow-hidden rounded-xl group ${item.className}`}>
              <img src={item.img} data-wvc-srcset={`${item.img}-wvc-srcset`} data-wvc-sizes={`${item.img}-wvc-sizes`} alt={item.title} className="absolute inset-0 w-full h-full object-cover transition-transform duration-700 group-hover:scale-105" loading="lazy" />
              {}
              <div className="absolute inset-0 bg-black/50 group-hover:bg-black/60 transition-colors duration-500" />
              
              <div className="relative z-10 flex flex-col justify-between h-full p-6 md:p-8">
                <div className="flex items-center gap-2">
                  <span className="text-sm font-mono text-primary font-medium">
                    {item.id}
                  </span>
                  {item.id === "05" && <span className="text-xs font-mono text-white/70 uppercase tracking-wider">
                      / Valore
                    </span>}
                </div>
                
                <div>
                  <h3 className="text-2xl md:text-3xl font-bold text-white mb-2 font-default">
                    {item.title}
                  </h3>
                  <p className="text-sm md:text-base text-white/80 leading-relaxed max-w-[90%]">
                    {item.desc}
                  </p>
                </div>
              </div>
            </motion.div>)}
        </motion.div>

        {}
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        amount: 0.5
      }} transition={{
        duration: 0.6,
        delay: 0.3
      }} className="mt-16 md:mt-24">
          <div className="bg-card border-l-4 border-primary rounded-r-xl p-8 md:p-10 shadow-sm max-w-4xl">
            <h3 className="text-2xl md:text-3xl lg:text-4xl font-bold text-foreground font-default mb-4 leading-tight">
              "L'altra <span className="text-primary">metà</span> dell'opera sei tu." <span className="text-foreground">Duchamp</span>
            </h3>
            <p className="text-muted-foreground text-base md:text-lg max-w-2xl leading-relaxed">
              La comunicazione non esiste senza chi la riceve. L'opera non è mai finita senza chi la guarda.
            </p>
          </div>
        </motion.div>

      </div>
    </section>;
}